import { Box, Checkbox } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { AbstractPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractPaymentMethod';
import { usePaymentMethods } from '@/components/modules/Application/components/PaymentMethod/_shared/hooks/usePaymentMethods';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { useScreen } from '@/hooks/useScreen';

interface WithPaymentMethodCardWrapperProps<T extends AbstractPaymentMethod> {
  paymentMethodEntity: T;
}

export const withPaymentMethodCardWrapper = <T extends AbstractPaymentMethod>(
  PaymentMethodCardComponent: React.ComponentType<WithPaymentMethodCardWrapperProps<T>>,
) => {
  return ({ paymentMethodEntity }: WithPaymentMethodCardWrapperProps<T>) => {
    const { lg, sm } = useScreen();
    const { updatePaymentMethodEntity } = usePaymentMethods();

    const handlePaymentMethodSelection = () => {
      updatePaymentMethodEntity(paymentMethodEntity.toggleSelected());
    };

    if (!paymentMethodEntity.isSetup) {
      return <Skeleton variant="rect" width={'100%'} height={lg ? '79px' : '201px'} />;
    }

    const CardInnerComponent = (
      <Box
        px={2}
        py={1}
        display="flex"
        flexDirection={'column'}
        style={{
          opacity: paymentMethodEntity.isSelected ? 1 : 0.5,
        }}
      >
        <PaymentMethodCardComponent paymentMethodEntity={paymentMethodEntity} />
      </Box>
    );

    const CardWithCheckboxOutside = (
      <Box display={'flex'} gridGap={8} alignItems={'top'}>
        <Box height={'66px'} display={'flex'} alignItems={'center'}>
          <Checkbox
            checked={paymentMethodEntity.isSelected}
            onChange={handlePaymentMethodSelection}
            style={{ marginLeft: '-12px' }}
          />
        </Box>
        <CustomPaper fill="paper" style={{ padding: 8 }}>
          {CardInnerComponent}
        </CustomPaper>
      </Box>
    );

    const CardWithCheckboxInside = (
      <CustomPaper fill="paper" style={{ paddingLeft: 36 }}>
        <Checkbox
          checked={paymentMethodEntity.isSelected}
          onChange={handlePaymentMethodSelection}
          style={{
            position: 'absolute',
            top: '10px',
            left: '10px',
            padding: '3px',
          }}
        />
        {CardInnerComponent}
      </CustomPaper>
    );

    if (sm) return CardWithCheckboxOutside;

    return CardWithCheckboxInside;
  };
};
